import { isUndefined } from 'util';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AWSConnectorService } from './aws-connector';
import { Injectable, NgZone } from '@angular/core';
import * as accountSummaries from 'javascript-api-utils/lib/account-summaries';

declare const gapi: any;
declare const $: any;

@Injectable()
export class GoogleAccountsService {
  gaToken = '';
  googleToken: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  selectedAccountAnalyticsId: any;
  selectedAccountViewId: any;


  constructor(
    private aws: AWSConnectorService,
    private ngZone: NgZone
  ) {
    this.aws.getAnalayticsKey().toPromise().then((key: any) => {
      this.gaToken = key.token;
      var that = this;
      gapi.analytics.ready(function () {
        gapi.analytics.auth.authorize({
          'serverAuth': {
            'access_token': that.gaToken
          }
        });
        that.ngZone.runOutsideAngular(() => {
          that.createViewSelector();
        });
      });
      this.googleToken.next(key.token);
    });

    setInterval(() => {
      this.aws.getAnalayticsKey().toPromise().then((key: any) => {
        this.gaToken = key.token;
        gapi.analytics.auth.authorize({
          'serverAuth': {
            'access_token': this.gaToken
          }
        });
        this.googleToken.next(key.token);
      });
    }, 5 * 60 * 1000);
  }

  /**
 * Adds event handlers and fetches the user's account information to
 * populate the view selector.
 */
  setup() {
    var that = this;
    accountSummaries.get().then(function (summaries) {
      console.log(summaries)
      let urlHash = that.getMapFromHash();
      let validIds = that.returnValidIds(summaries, urlHash);
      let allIds = that.getAllIds(summaries, validIds, false);

      that.setViewSelector(allIds['viewId']);
    });
  }


  getMapFromHash() {
    let urlHash = document.location.hash.substr(1);
    let params = urlHash.split('&');
    let map = {};
    for (let i = 0, param; param = params[i]; i++) {
      let fragment = param.split('=');
      map[fragment[0]] = fragment[1];
    }
    return map;
  }


  /**
 * Given a potentially invalid view and/or property and/or account ID(s),
 * returns an object with only the valid view, property, and account IDs
 * (among those given).
 * @param {Object} summaries The account summaries response.
 * @param {Object} ids An object with one or more of the following: viewId,
 *     property ID, account ID.
 * @return {Object} An object with only the valid view, property, and account
 *     IDs (among those given).
 */
  returnValidIds(summaries, ids) {
    if (ids.viewId) {
      let view = summaries.getProfile(ids.viewId);
      ids.viewId = view ? view.id : null;
    }
    if (ids.propertyId) {
      let property = summaries.getProperty(ids.propertyId);
      ids.propertyId = property ? property.id : null;
    }
    if (ids.accountId) {
      let account = summaries.getAccount(ids.accountId);
      ids.accountId = account ? account.id : null;
    }
    return ids;
  }

  /**
 * Given a valid view and/or property and/or account ID(s), returns an
 * object with the associated view, property, and account IDs. If no view is
 * given, it will return the first view in the property. Similarly, if no
 * property is given, it will return the first property in the account and the
 * first view in the property.
 * @param {Object} summaries The account summaries response.
 * @param {Object} ids An object with the viewId, the property ID, and the
 *     account ID.
 * @param {Boolean} returnObject If true, will return the view, property, and
 *     account object. If false, will return the IDs.
 * @return {Object} All the associated view, property, and account IDs. If
 *     returnObject is true, will return the account objects, not the IDs.
 */
  getAllIds(summaries, ids, returnObject) {
    let accountObject = {

    };
    if (ids.viewId) {
      accountObject['view'] = summaries.getView(ids.viewId);
      accountObject['property'] = summaries.getPropertyByViewId(ids.viewId);
      accountObject['account'] = summaries.getAccountByViewId(ids.viewId);
    } else if (ids.propertyId) {
      accountObject['property'] = summaries.getProperty(ids.propertyId);
      accountObject['account'] =
        summaries.getAccountByWebPropertyId(ids.propertyId);
      // pick first profile
      accountObject['view'] = accountObject['property'].views[0];
    } else if (ids.accountId) {
      accountObject['account'] = summaries.getAccount(ids.accountId);
      // pick first property and first profile
      accountObject['property'] = accountObject['account'].properties[0];
      accountObject['view'] =
        summaries.getProperty(accountObject['property'].id).views[0];
    } else {
      // pick first view property and account
      accountObject['account'] = summaries.all()[0];
      accountObject['property'] = accountObject['account'].properties[0];
      accountObject['view'] = accountObject['property'].views[0];
    }

    return returnObject ? accountObject : {
      viewId: accountObject['view'].id,
      propertyId: accountObject['property'].id,
      accountId: accountObject['account'].id
    };
  }

  /**
 * Creates and sets the viewSelector
 * @param {String} viewId The view ID to set the viewSelector to
 */
  setViewSelector(viewId) {
    var that = this;
    let viewSelector = new gapi.analytics.ext.ViewSelector2({
      container: 'view-selector-container',
    }).execute();

    viewSelector.set({ viewId: viewId });

    let getIdsAndUpdateResults = () => {
      // Use a try/catch block in case we have sparse properties or accounts.
      try {
        let allObjects = {
          view: viewSelector.view,
          property: viewSelector.property,
          account: viewSelector.account,
        };
        this.selectedAccountAnalyticsId = `${ allObjects['property']['id'] }`;
        this.selectedAccountViewId = `ga:${ allObjects['view']['id'] }`;
        console.log('allObjects  sdaf: ', allObjects)
      } catch (e) {
        // No action.
      }
    };

    viewSelector.on('change', () => {
      // Use a try/catch block in case we have sparse properties or accounts.
      try {
        let allObjects = {
          view: viewSelector.view,
          property: viewSelector.property,
          account: viewSelector.account,
        };
        this.selectedAccountAnalyticsId = `${ allObjects['property']['id'] }`;
        this.selectedAccountViewId = `ga:${ allObjects['view']['id'] }`;
        console.log('allObjects: ', allObjects['view']['id'], allObjects['account']['id'])
        // that.updateResults([allObjects], allObjects['account']['name']);
      } catch (e) {
        // No action.
      }
    });
    $('#view-selector-container').on('focusout', getIdsAndUpdateResults);
  }



  createViewSelector() {
    var that = this;

    gapi.analytics.createComponent('ViewSelector2', {

      /**
       * Render the view selector instance on the page or update an existing
       * instance if any options have changed.
       * @return {ViewSelector2} The instance.
       */
      execute: function () {
        this.setup_(function () {
          this.updateAccounts_();
          if (this.changed_) {
            this.render_();
            this.onChange_();
          }
        }.bind(this));

        return this;
      },

      /**
       * Extend the base `set` function with some error checking and handling of
       * ID data.
       * @extends gapi.analytics.Component.prototype.set
       * @param {Object} opts The options to set.
       * @return {ViewSelector2}
       */
      set: function (opts) {
        if (Number(!!opts.ids) + Number(!!opts.viewId) + Number(!!opts.propertyId) + Number(!!opts.accountId) > 1) {
          throw new Error('You cannot specify more than one of the following ' +
            'options: "ids", "viewId", "accountId", "propertyId"');
        }

        if (opts.container && this.container) {
          throw new Error('You cannot change containers once a view selector ' +
            'has been rendered on the page.');
        }

        let prevOpts = this.get();

        if (prevOpts.ids != opts.ids ||
          prevOpts.viewId != opts.viewId ||
          prevOpts.propertyId != opts.propertyId ||
          prevOpts.accountId != opts.accountId) {
          // If new ID data is being set, first unset all existing ID data.
          // This prevents the problem where you set an account ID then set a
          // view ID for a new view in a different account. Both IDs should not
          // persist or there will be problems.
          prevOpts.ids = null;
          prevOpts.viewId = null;
          prevOpts.propertyId = null;
          prevOpts.accountId = null;
        }

        // Call super.
        return gapi.analytics.Component.prototype.set.call(this, opts);
      },

      /**
       * Set up the view selector instance with values from the Management API's
       * accountSummaries.list method via the `accountSummaries` module.
       * If the user has not authorized, wait until that happens before
       * requesting the account summaries.
       * @param {Function} cb A function to be invoked once authorization has
       *     succeeded and the accountSummaries have been retrieved.
       */
      setup_: function (cb) {
        let self = this;

        let onAuthorize = function () {
          accountSummaries.get().then(
            function (summaries) {
              self.summaries = summaries;
              self.accounts = self.summaries.all();
              cb();
            },
            function (err) {
              self.emit('error', err);
            }
          );
        };

        if (gapi.analytics.auth.isAuthorized()) {
          onAuthorize();
        } else {
          gapi.analytics.auth.on('signIn', onAuthorize);
        }
      },

      /**
       * Update the view selector instance properties with new account
       * information.
       */
      updateAccounts_: function () {
        let opts = this.get();
        let ids = that.getIdProp(opts);
        let view;
        let account;
        let property;

        // If the user does not have any accounts, emit an error.
        if (!this.summaries.all().length) {
          this.emit('error', new Error('This user does not have any ' +
            'Google Analytics accounts. You can sign up at ' +
            '"www.google.com/analytics".'));
          return;
        }

        // If there are no id props, set the defaults.
        if (!ids) {
          account = this.accounts[0];
          property = account && account.properties && account.properties[0];
          view = property && property.views && property.views[0];
        } else {
          switch (ids.prop) {
            case 'viewId':
              view = this.summaries.getProfile(ids.value);
              account = this.summaries.getAccountByProfileId(ids.value);
              property = this.summaries.getWebPropertyByProfileId(ids.value);
              break;
            case 'propertyId':
              property = this.summaries.getWebProperty(ids.value);
              account = this.summaries.getAccountByWebPropertyId(ids.value);
              view = property && property.views && property.views[0];
              break;
            case 'accountId':
              account = this.summaries.getAccount(ids.value);
              property = account && account.properties && account.properties[0];
              view = property && property.views && property.views[0];
              break;
          }
        }

        if (account || property || view) {
          // Only update if something has changed.
          if (account != this.account ||
            property != this.property ||
            view != this.view) {
            // Store what value changed.
            this.changed_ = {
              account: account && account != this.account,
              property: property && property != this.property,
              view: view && view != this.view,
            };

            this.account = account;
            this.properties = account.properties;
            this.property = property;
            this.views = property && property.views;
            this.view = view;
            this.ids = view && 'ga:' + view.id;
          }
        } else {
          this.emit('error', new Error('This user does not have access to ' +
            ids.prop.slice(0, -2) + ' : ' + ids.value));
        }
      },

      /**
       * Render the view selector based on the users accounts and the
       * pre-defined template. Also add event handlers to watch for
       * changes.
       */
      render_: function () {
        let opts = this.get();

        this.container = typeof opts.container == 'string' ?
          document.getElementById(opts.container) : opts.container;

        this.container.innerHTML = opts.template || this.template;
        let selects = this.container.querySelectorAll('select');

        let accounts = this.accounts;
        let properties = this.properties || [{ name: '(Empty)', id: '' }];
        let views = this.views || [{ name: '(Empty)', id: '' }];

        that.updateSelect(selects[0], accounts, this.account.id);
        that.updateSelect(selects[1], properties, this.property && this.property.id);
        that.updateSelect(selects[2], views, this.view && this.view.id);

        selects[0].onchange =
          this.onUserSelect_.bind(this, selects[0], 'accountId');
        selects[1].onchange =
          this.onUserSelect_.bind(this, selects[1], 'propertyId');
        selects[2].onchange =
          this.onUserSelect_.bind(this, selects[2], 'viewId');
      },

      /**
       * A callback that is invoked from the `execute` method whenever the ID
       * data has changed. Most of the time this change happens when the user
       * has selected a new view in the UI, but it can also happen
       * programmatically via the `set` method.
       */
      onChange_: function () {
        let props = {
          account: this.account,
          property: this.property,
          view: this.view,
          ids: this.view && 'ga:' + this.view.id,
        };

        if (this.changed_) {
          if (this.changed_.account) this.emit('accountChange', props);
          if (this.changed_.property) this.emit('propertyChange', props);
          if (this.changed_.view) {
            this.emit('viewChange', props);
            this.emit('idsChange', props);

            // For backwards compatibility with the original ViewSelector.
            this.emit('change', props.ids);
          }
        }

        this.changed_ = null;
      },

      /**
       * The handler assigned to the `onchange` method of each of the select
       * elements. The context is bound to the view selector instance and it is
       * invoked with the element and property as its arguments.
       * @param {HTMLSelectElement} select The select element.
       * @param {string} property The property key to be set on the instance.
       */
      onUserSelect_: function (select, property) {
        let data = {};
        data[property] = select.value;

        this.set(data);
        this.execute();
      },

      /**
       * The html structure used to build the component. Developers can override
       * this by passing it to the component constructor.  The only requirement
       * is that the structure contain three selects.  The first will be the
       * account select, the second will be the property select, and the third
       * will be the view select. Order is important.
       */
      template:
        '<div class="ViewSelector2">' +
        '  <div class="ViewSelector2-item">' +
        '    <label>Account</label>' +
        '    <select class="FormField"></select>' +
        '  </div>' +
        '  <div class="ViewSelector2-item">' +
        '    <label>Property</label>' +
        '    <select class="FormField"></select>' +
        '  </div>' +
        '  <div class="ViewSelector2-item">' +
        '    <label>View</label>' +
        '    <select class="FormField"></select>' +
        '  </div>' +
        '</div>',
    });

  }


  /**
    * Update a select with the specified options and optionally choose the
    * selected option based on the matching ID.
    * @param {HTMLSelectElement} select The select element to update.
    * @param {Array} options An Array of objects with the keys
    *     `name` and `id`.
    * @param {string} [selectedId] An optional value used to determine
    *     the selected option.
    */
  updateSelect(select, options, selectedId) {
    select.innerHTML = options.map(({ id, name }) =>
      `<option ${ id == selectedId ? 'selected' : '' } value="${ id }">
          ${name }
        </option>`
    ).join('');
  }


  /**
   * Given an options object containing a single key that could be either
   * "ids", "viewId", "propertyId", or "accountId", return a new object
   * specifying that key in its `prop` property. If the passed property is
   * "ids" convert it to "viewId".
   * @param {Object} opts An options object.
   * @return {Object} An object specifying what ID property and value were
   *     passed.
   */
  getIdProp(opts) {
    if (opts.ids || opts.viewId) {
      return {
        prop: 'viewId', value: opts.viewId ||
          (opts.ids && opts.ids.replace(/^ga:/, ''))
      };
    } else if (opts.propertyId) {
      return { prop: 'propertyId', value: opts.propertyId };
    } else if (opts.accountId) {
      return { prop: 'accountId', value: opts.accountId };
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/google-accounts.service.ts